import axios from "axios";
import router from "@/router";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const tabId = window.name || `tab_${Date.now()}`;
  const token = localStorage.getItem(`access_token_${tabId}`);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const tabId = window.name || `tab_${Date.now()}`;
      localStorage.removeItem(`access_token_${tabId}`);
      localStorage.removeItem(`refresh_token_${tabId}`);
      localStorage.removeItem(`fbo_id_${tabId}`);
      alert("你的登錄已過期，請重新登錄。");
      if (router.currentRoute.path !== "/") {
        router.push("/");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
